var PageProfile = ( function($) {

    PageProfile = function(options) {
        var that = this;

        that.class = {
            sticky_observer: 'js-sticky-observer',
            is_stick: 'is-stick'
        }

        // DOM
        that.$wrapper = options['$wrapper'];

        // CONST

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    PageProfile.prototype.init = function() {
        var that = this;

        //
        $.sa.stickyObserver('.' + that.class.sticky_observer, that.class.is_stick);
    };

    

    return PageProfile;
})($);